function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.063 44.375" {...props}><title>icon-lock</title><path d="M27.625 18.972v-7.878A10.986 10.986 0 0 0 16.531 0 10.986 10.986 0 0 0 5.438 11.094v7.878C2.775 21.856 0 24.628 0 28.844 0 37.5 7.878 44.375 16.531 44.375S33.063 37.5 33.063 28.844c0-4.216-2.775-6.988-5.438-9.872zm-17.75-.106v-7.772a6.537 6.537 0 0 1 6.656-6.656 6.537 6.537 0 0 1 6.656 6.656v7.772m-6.656 2.884" fill="#010101" /></svg>;
});